export default __webpack_public_path__ + "static/media/remodel4.5fe33b90.png";